'use client'

import { PricingRuleModel, isFactGroup } from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { CountryModel } from '@marketplace-web/domain/country-data'
import { CatalogNavigationModel } from '@marketplace-web/catalog/catalog-data'

import FactGroupSection from '../FactGroupSection'

type Props = {
  priceRule: PricingRuleModel
  countries?: Array<CountryModel> | null
  catalogs: Array<CatalogNavigationModel>
}

const FactGroupList = ({ priceRule, countries, catalogs }: Props) => {
  const factGroupList = priceRule.conditionTree.all.items.filter(isFactGroup)

  return factGroupList.map(factGroup => (
    <div data-testid="available-discount__fact-group-item" key={factGroup.id}>
      <FactGroupSection
        catalogs={catalogs}
        countries={countries}
        factGroup={factGroup}
        currencyCode={priceRule.currency}
      />
    </div>
  ))
}

export default FactGroupList
